import React, { useState } from "react";
import { Sparkles, RefreshCw } from "lucide-react";
import { endpoints } from "@/lib/api";
import { usePoll } from "@/hooks/usePoll";
import { Panel } from "@/components/common";
import { renderMarkdown } from "@/lib/markdown";

export default function AIBrief() {
  const { data, refresh } = usePoll(endpoints.cachedBrief, 15000);
  const [loading, setLoading] = useState(false);

  const generate = async () => {
    setLoading(true);
    try {
      await endpoints.generateBrief();
      await refresh();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Panel
      testid="ai-executive-brief"
      title="AI Executive Brief"
      subtitle="AI Powered · Data → Physics → Economics → Action"
      right={
        <button
          onClick={generate}
          disabled={loading}
          data-testid="generate-brief-btn"
          className="flex items-center gap-1.5 px-3 py-1.5 bg-slate-900 text-white text-xs font-semibold rounded hover:bg-slate-700 disabled:opacity-60 transition-colors"
        >
          <RefreshCw size={13} className={loading ? "animate-spin" : ""} />
          {loading ? "Analysing…" : data?.text ? "Refresh" : "Generate"}
        </button>
      }
    >
      {data?.text ? (
        <div
          className="prose-sm max-w-none text-sm text-slate-700 leading-relaxed [&_h2]:text-base [&_h2]:font-semibold [&_h2]:text-slate-900 [&_h2]:mb-2 [&_strong]:text-slate-900 [&_li]:my-1"
          data-testid="ai-brief-text"
          dangerouslySetInnerHTML={{ __html: renderMarkdown(data.text) }}
        />
      ) : (
        <div className="flex items-center gap-2 text-sm text-slate-400 py-6 justify-center">
          <Sparkles size={16} className="text-violet-400" />
          Generate the live executive brief — the AI reasons over current twin & economics data.
        </div>
      )}
    </Panel>
  );
}
